import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ButtonUI from  '../../../../components/UI/ButtonUI';
import { translate } from '../../../../utils/util';
import { Row, Modal, Button } from 'react-materialize';

const ConfirmationModal = (props) => {
    return (
        <Modal
            open={props.open}
            id={props.id || 'ModalPackList'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={props.onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close">
                        {translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={props.onConfirm} text={translate('confirm', 'general')} />
                </Row>
            }
        >
            <div>
                <Row className="center">
                    <div className="sixth-text-color center">
                        <span className="title col s12">Confirmação</span>
                        <span className="col s12">{props.items.length} encontrado(s). Deseja alterar todos os registros?</span>
                    </div>
                </Row>
            </div>
        </Modal>
    );
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmationModal)));
